document.addEventListener('DOMContentLoaded', function () {
    var P = window.IM3_PRODUCTS || [];
    var section = document.querySelector('[data-im3]');
    if (!section || P.length < 2) return;

    var stage = document.getElementById('im3Stage');
    var fallbackImg = document.getElementById('im3Fallback');
    var nameEl = document.getElementById('im3Name');
    var idxEl = document.getElementById('im3Idx');
    var buyEl = document.getElementById('im3Buy');
    var dots = document.querySelectorAll('#im3Dots i');
    var pin = section.querySelector('.im3-pin');

    function luminance(hex) {
      var c = hex.replace('#',''); if (c.length === 3) c = c.split('').map(function(x){return x+x;}).join('');
      var r = parseInt(c.substr(0,2),16)/255, g = parseInt(c.substr(2,2),16)/255, b = parseInt(c.substr(4,2),16)/255;
      return 0.2126*r + 0.7152*g + 0.0722*b;
    }

    var decalMat = null, decalTextures = [];
    var current = -1;
    function setSegment(i) {
      if (i === current) return;
      current = i;
      nameEl.textContent = P[i].title;
      idxEl.textContent = ('0' + (i+1)).slice(-2);
      buyEl.href = P[i].url;
      buyEl.innerHTML = 'Comprar ' + P[i].price + ' <span class="im-arr">&rarr;</span>';
      pin.style.setProperty('--im3-bg', P[i].bg);
      pin.style.setProperty('--im3-fg', luminance(P[i].bg) > 0.45 ? '#171716' : '#FAFAF7');
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (decalMat && decalTextures[i]) { decalMat.map = decalTextures[i]; decalMat.needsUpdate = true; }
      if (fallbackImg) fallbackImg.src = P[i].img;
    }
    setSegment(0);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Fallback sin WebGL/three.js: rotar la imagen plana
    function startFallbackCycle() {
      if (reduce) return;
      setInterval(function () { setSegment((current + 1) % P.length); }, 3500);
    }
    if (typeof THREE === 'undefined') { startFallbackCycle(); return; }

    // WebGL support check
    var testCanvas = document.createElement('canvas');
    var gl = testCanvas.getContext('webgl') || testCanvas.getContext('experimental-webgl');
    if (!gl) { startFallbackCycle(); return; }

    // ---------- three.js scene ----------
    var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    var maxAniso = renderer.capabilities.getMaxAnisotropy() || 8;
    stage.appendChild(renderer.domElement);
    fallbackImg.style.display = 'none';

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(35, 1, 0.1, 20);
    camera.position.set(0, 0, 1.35);

    // Iluminacion de "sala de exposicion": un foco conico cenital, mas
    // cerrado y contrastado (como un spot de museo/escaparate), con
    // penumbra suave, sombra propia y el resto de la escena en penumbra.
    scene.add(new THREE.AmbientLight(0xffffff, 0.22));
    var spotTarget = new THREE.Object3D();
    spotTarget.position.set(0, 0.04, 0.06);
    scene.add(spotTarget);
    var key = new THREE.SpotLight(0xffffff, 3.1, 8, Math.PI / 11, 0.5, 1);
    key.position.set(0.18, 2.4, 0.7);
    key.target = spotTarget;
    key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.bias = -0.0016;
    key.shadow.radius = 5;
    scene.add(key);
    var fill = new THREE.DirectionalLight(0xffffff, 0.16);
    fill.position.set(-1, 0.3, 1.6);
    scene.add(fill);
    var rim = new THREE.DirectionalLight(0xffffff, 0.4);
    rim.position.set(-1.6, 0.7, -2);
    scene.add(rim);

    var group = new THREE.Group();
    scene.add(group);

    // Draw each chest print on a high-res canvas using the site font
    function makeDecalTexture(title) {
      var words = title.toUpperCase().split(' ');
      var lines;
      if (words.length <= 2 || title.length <= 11) {
        lines = [words.join(' ')];
      } else {
        var best = 1, bestDiff = 1e9;
        for (var k = 1; k < words.length; k++) {
          var a = words.slice(0, k).join(' ').length, b = words.slice(k).join(' ').length;
          var diff = Math.abs(a - b);
          if (diff < bestDiff) { bestDiff = diff; best = k; }
        }
        lines = [words.slice(0, best).join(' '), words.slice(best).join(' ')];
      }
      var S = 2048;
      var cv = document.createElement('canvas'); cv.width = S; cv.height = S;
      var ctx = cv.getContext('2d');
      ctx.fillStyle = '#171716';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var fs = 380;
      do {
        ctx.font = '800 ' + fs + "px 'Archivo', sans-serif";
        var maxW = Math.max.apply(null, lines.map(function (t) { return ctx.measureText(t).width; }));
        if (maxW <= S * 0.86) break;
        fs -= 16;
      } while (fs > 80);
      var lh = fs * 1.14;
      var y0 = S / 2 - (lines.length - 1) * lh / 2;
      lines.forEach(function (t, li) { ctx.fillText(t, S / 2, y0 + li * lh); });
      var tex = new THREE.CanvasTexture(cv);
      tex.encoding = THREE.sRGBEncoding;
      tex.anisotropy = maxAniso;
      return tex;
    }
    function buildDecals() {
      P.forEach(function (p, i) { decalTextures[i] = makeDecalTexture(p.title); });
      if (decalMat) { decalMat.map = decalTextures[current]; decalMat.needsUpdate = true; }
    }
    buildDecals();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildDecals);

    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    resize();
    window.addEventListener('resize', resize);

    var loader = new THREE.GLTFLoader();
    loader.load(window.IM3_MODEL, function (gltf) {
      var model = gltf.scene;
      var shirtMesh = null;
      model.traverse(function (o) {
        if (o.isMesh) {
          shirtMesh = o;
          o.material.color = new THREE.Color('#ffffff');
          o.material.roughness = 0.75;
          o.castShadow = true;
          o.receiveShadow = true;
        }
      });

      // center the model in the group
      var box = new THREE.Box3().setFromObject(model);
      var center = box.getCenter(new THREE.Vector3());
      model.position.sub(center);
      group.add(model);

      // Escenario: ajusta la sombra del foco al tamano real de la camiseta
      // y le pone debajo un "suelo" que solo recibe su sombra (invisible en lo demas)
      var bounds = new THREE.Box3().setFromObject(model);
      var dims = bounds.getSize(new THREE.Vector3());
      var maxDim = Math.max(dims.x, dims.y, dims.z);
      key.shadow.camera.near = 0.2;
      key.shadow.camera.far = maxDim * 5;
      key.shadow.camera.updateProjectionMatrix();

      var floor = new THREE.Mesh(
        new THREE.PlaneGeometry(dims.x * 4, dims.z * 4),
        new THREE.ShadowMaterial({ opacity: 0.36 })
      );
      floor.rotation.x = -Math.PI / 2;
      floor.position.y = bounds.min.y + 0.001;
      floor.receiveShadow = true;
      group.add(floor);

      // chest decal (projected onto the mesh at rotation 0) - mas pequeno y nitido
      if (shirtMesh && THREE.DecalGeometry) {
        shirtMesh.updateMatrixWorld(true);
        var b2 = new THREE.Box3().setFromObject(model);
        var size = b2.getSize(new THREE.Vector3());
        var pos = new THREE.Vector3(0, size.y * 0.1, b2.max.z);
        var orient = new THREE.Euler(0, 0, 0);
        var s = size.y * 0.4;
        var dg = new THREE.DecalGeometry(shirtMesh, pos, orient, new THREE.Vector3(s, s, s));
        decalMat = new THREE.MeshStandardMaterial({
          map: decalTextures[current] || decalTextures[0],
          transparent: true,
          depthWrite: false,
          polygonOffset: true,
          polygonOffsetFactor: -4,
          roughness: 0.75
        });
        // El estampado NO recibe sombra: si la recibe, los pliegues de la
        // camiseta proyectan bandas oscuras justo encima del texto y las
        // letras parecen "hundirse" o cortarse a media letra.
        var decalMesh = new THREE.Mesh(dg, decalMat);
        group.add(decalMesh);
      }
    });

    var inView = true;
    new IntersectionObserver(function (es) { es.forEach(function (e) { inView = e.isIntersecting; }); }).observe(section);

    // ---------- rotation engine ----------
    // La camiseta gira sola, sin tocar el scroll de la pagina.
    // Arrastrarla la lanza mas rapido (o mas lento / hacia atras); luego
    // vuelve suavemente a su velocidad de crucero. El diseno y el fondo
    // cambian cada vez que la espalda mira al espectador.
    var BASE_SPEED = reduce ? 0 : 32;   // grados por segundo
    var rot = 0, speed = BASE_SPEED;
    var dragging = false, lastX = 0, lastMoveT = 0, dragVel = 0;

    stage.addEventListener('pointerdown', function (e) {
      dragging = true; lastX = e.clientX; lastMoveT = performance.now(); dragVel = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now();
      var dx = e.clientX - lastX;
      rot += dx * 0.6;
      var dtm = Math.max(now - lastMoveT, 8) / 1000;
      dragVel = dragVel * 0.6 + (dx * 0.6 / dtm) * 0.4;
      lastX = e.clientX; lastMoveT = now;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var v = Math.max(-1200, Math.min(1200, dragVel));
      if (Math.abs(v) > 40) speed = v;
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    var lastFrameT = 0;
    function render(now) {
      var dt = lastFrameT ? Math.min((now - lastFrameT) / 1000, 0.1) : 0.016;
      lastFrameT = now;
      if (!dragging) {
        speed += (BASE_SPEED - speed) * Math.min(1, dt * 0.5);
        rot += speed * dt;
      }
      group.rotation.y = rot * Math.PI / 180;
      group.rotation.x = Math.sin(rot * Math.PI / 360) * 0.05 + 0.04;
      var seg = Math.floor((rot + 180) / 360) % P.length;
      if (seg < 0) seg += P.length;
      setSegment(seg);
      renderer.render(scene, camera);
    }
    (function loop(t) { requestAnimationFrame(loop); if (inView) render(t); })(0);
  });
